import GenieThreadBaseController from 'webapp/controllers/genie-thread-base';

export default class MobileGenieChatController extends GenieThreadBaseController {}
